require('./_set-species')('Array');



//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/core-js/modules/es6.array.species.js
// module id = 602
// module chunks = 0